import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=cargando, null=no auth, obj=auth
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    if (!getToken()) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  // Renueva el token cada 24h si hay sesión activa, para mantener la sesión viva muchos días
  useEffect(() => {
    if (!user) return;
    const iv = setInterval(async () => {
      try {
        const { data } = await api.post("/auth/refresh");
        if (data?.token) setToken(data.token);
      } catch { /* interceptor maneja 401 */ }
    }, 24 * 60 * 60 * 1000);
    return () => clearInterval(iv);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { setToken(null); setUser(null); };

  const refresh = fetchMe;

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
